<template>
    <div>
        <Button @click="additem">{{$t('global.common.operation_add',{defaultValue:'添加'})}}</Button>
        <Table
        class="margin-top-20"
        :loading="loading"
        :columns="columns"
        :data="datalist"
        size="small"
        ref="table"
        border
        ></Table>
        <div class="color-error">{{$t('erp.disturibution.manualback_attention_tip',{defaultValue:'注意：如果ERP SKU、发货数量不填，默认整个配货单只有一个包裹。'})}}</div>
        <footer class="text-right margin-top-10">
             <Button type="primary" @click="clickModal">{{$t('erp.disturibution.manual_back_return',{defaultValue:'回传'})}}</Button>
             <Button class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
        </footer>

        <!-- 弹框 -->
        <Modal v-model="operate.show" :z-index="9999" width="360" @on-cancel="close('all')" :mask-closable="false" :key="operate.index+1">
            <div slot="header" style="color:#f60;text-align:center">
                <p>{{operate.title}}</p>
            </div>
            <div style="text-align:center">
                <p>{{operate.content}}</p>
            </div>
            <div slot="footer">
                <Button type="error" size="large" :loading="showDel" long @click="submit">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</Button>
            </div>
        </Modal>

         <Spin size="large" fix v-if="formloading"></Spin>
    </div>
</template>
<script>
import {
    HttpManualBack
} from "@/service/boss/distribution";
import { HttpGetAllCustomerIdCode} from '@/service/boss/b2corder'

export default {
    props:["orderData"],
    data(){
        return {
            formloading:false,
            loading:false,
            id: this.orderData.id,
            // issuper: this.$route.query.issuper == 1,
            datalist:[],
            volumeTypes:[],
            nowdate:"",
            judge:false,
            operate:{
                // loading:true,
                show:false,
                title:"",
                content:"",
                oktext:this.$t('global.common.update_OK',{defaultValue:'确定'}),
                canceltext:this.$t('global.common.operation_cancel',{defaultValue:'取消'}),
                index:1,
            },
            // orgWarehouseId:"",
            showDel:false,
        }
    },
    computed:{
        columns() {
            const _this = this
            return [
            {
                // title: 'Tracking NO',
                key: 'trackingNo',
                renderHeader:(h,params)=>{
                    return h('div',[
                        h('Icon',{
                            props:{
                                type:"ios-medical",
                                color:"#ed3f14"
                            },
                        }),
                        h('strong','Tracking NO')
                    ])
                },
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('Input',{
                            props: {
                                size:'small',
                                value:row.trackNo
                            },
                            on: {
                                'input':(event) => {
                                    row.trackNo = event
                                    _this.datalist[index] = row
                                }
                            },
                        })
                    }else{
                        return <div>
                        {row.trackNo}
                        </div>
                    }
                }
            }, {
                // title: '',
                key: 'carrier',
                renderHeader:(h,params)=>{
                    return h('div',[
                        h('Icon',{
                            props:{
                                type:"ios-medical",
                                color:"#ed3f14"
                            },
                        }),
                        h('strong','Carrier')
                    ])
                },
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('Select',{
                            props:{
                                value: _this.datalist[index].serviceCode,
                            },
                            on: {
                                'on-change':(value) => {
                                    _this.datalist[index].serviceCode = value
                                }
                            },
                        },
                            _this.volumeTypes.map((json)=>{
                                // console.log(json)
                                return h('Option', {
                                    props: json
                                });
                            })
                        )
                    }else{
                        return <div>{row.serviceCode}</div>
                    }
                }
            }, {
                title: 'ERP SKU',
                key: 'erpSku',
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('Input',{
                            props: {
                                size:'small',
                                value:row.erpSku
                            },
                            on: {
                                'input': (event) => {
                                    row.erpSku = event
                                    _this.datalist[index] = row
                                }
                            },
                        })
                    }else{
                        return <div>{row.erpSku}</div>
                    }
                }
            }, {
                title: this.$t('erp.b2c.quantity_shipped',{defaultValue:'发货数量'}),
                key: 'shipedQuantity',
                width:120,
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('InputNumber',{
                            props: {
                                size:'small',
                                min:1,
                                value:row.shipedQuantity
                            },
                            on: {
                                'input': (event) => {
                                    row.shipedQuantity = event
                                    _this.datalist[index] = row
                                }
                            },
                        })
                    }else{
                        return <div>{row.shipedQuantity}</div>
                    }
                }
            },{
                title: 'Shipping Cost',
                key: 'cost',
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('Input',{
                            props: {
                                size:'small',
                                value:row.shippingCost
                            },
                            on: {
                                'input': (event) => {
                                    row.shippingCost = event
                                    _this.datalist[index] = row
                                }
                            },
                        })
                    }else{
                        return <div>{row.shippingCost}</div>
                    }
                }
            },{
                // title: '',
                key: 'shipmentDate',
                width:220,
                renderHeader:(h,params)=>{
                    return h('div',[
                        h('Icon',{
                            props:{
                                type:"ios-medical",
                                color:"#ed3f14"
                            },
                        }),
                        h('strong',this.$t('erp.b2c.search_outtime',{defaultValue:'发货时间'}))
                    ])
                },
                render(h, { row,index }) {
                    if(row.$Edit){
                        return h('DatePicker',{
                            props: {
                                type:'datetime',
                                placeholder:"Select date",
                                value:_this.datalist[index].shipmentDate
                            },
                            on: {
                                'on-change':function(date){
                                    // console.log(date)
                                    _this.datalist[index].shipmentDate = date
                                },
                            },
                        })
                    }else{
                        return <div>{row.shipmentDate}</div>
                    }
                }
            },{
                title: this.$t('global.common.operation',{defaultValue:'操作'}),
                width:140,
                render(h, { row, index }) {
                    return h('div',[
                        h('Button', {
                            props:{
                                type:"primary",
                                size:'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    _this.changeEdit(row)
                                }
                            }
                        },_this.$t('global.common.operation_edit',{defaultValue:'编辑'})),
                        h('Button', {
                            props:{
                                type:"error",
                                size:'small'
                            },
                            on: {
                                click: () => {
                                    _this.comremove(index)
                                }
                            }
                        },_this.$t('global.common.delete',{defaultValue:'删除'}))
                    ])
                }
            },]
        },
    },
    created(){
        this.getNowFormatDate()
        this.getpackages()
        
        // alert(1)
        // console.log(123)
        // HttpActiveGetService().then(res => {
        //     console.log(res)
        // }, err => {
        //     this.$VMessage.error(err.message)
        // })
    },
    methods:{
         // 点击出弹框
        clickModal() {
            // console.log(112345)
            this.operate.show = true;
            this.operate.title = this.$t("erp.b2c.manual_back", { defaultValue: "手动回传" }),
            this.operate.content = this.$t('erp.distribution.manual_desc',{defaultValue:'确定强制手动回传？强制手动回传会直接将Tracking信息回传，不会推送到仓库！'})
            // this.operate = {
            //     show:true,
            //     title: '',
            //     content: "订单重置后会恢复初始状态，并变为手工订单，是否确认提交？",
            //     // type:val,
            // }
        },
        getNowFormatDate(){
            let date = new Date();
            let seperator1 = "-";
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            let currentdate = year + seperator1 + month + seperator1 + strDate;
            this.nowdate =  currentdate;
            // console.log(this.nowdate)
        },
        getpackages(){
            let _this = this
            this.loading = true
            // this.orgWarehouseId = this.warehouseid
            // HttpqueryB2COrder({
            //     orderId: this.activeids,
            //     node:this.nodeid,
            //     // contextId: 1
            // }).then(res => {
                // console.log(this.orderData,'orderData')
                let resdata = this.orderData.saleShipmentPackagesList;
                // console.log(resdata);
                if(resdata==null){
                    resdata = []
                }else{
                    resdata.map(item=>{
                        item.$Edit = false
                    })
                }
                // if(!res.data.logistics.orgWarehouseCode){
                //     this.$Message.error('未分配仓库，发货方式不存在');
                // }else{
                    // _this.formloading = true;
                    // HttpPlatformSystem({
                    //     page: 1,
                    //     rows: 500,
                    //     sidx: 'id',
                    //     sord: 'desc',
                    //     // orderType:200
                    // }).then(res=>{
                    //     let array = res.data.content.map(item=>{
                    //         return item.carrierServiceCode
                    //     })
                    //     array = array.sort(function(a,b){
                    //         return a.localeCompare(b)
                    //     })
                    //     _this.volumeTypes = Array.from(new Set(array))
                    // })
                    HttpGetAllCustomerIdCode().then(res => {
                        let array = res.data.map(item => {
                            // return item.carrierServiceCode
                            return {
                                value: item.code,
                                label: `${item.code}(${item.carrierServiceName})`
                            }
                        })
                        array = array.sort(function(a,b){
                            return a.value.localeCompare(b.value)
                        })
                        _this.volumeTypes = Array.from(new Set(array))
                    }, err => {
                        this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
                    })
                // }

                let filterarr = resdata.filter(item=> {return item.packageFlag == 0}) || []
                if(filterarr.length<1){
                    this.datalist = resdata || []
                }else{
                    this.datalist = filterarr || []
                }

                this.loading = false;
            // }, err => {
            //     this.loading = false;
            // });

        },
        additem(){
            let _this = this
            let itemdata = {
                trackingNo:null,
                carrier:null,
                erpSku:null,
                cost:null,
                shipedQuantity:null,
                shipmentDate:_this.nowdate+' 18:00:00',
                $Edit:true,
            }
            this.datalist.push(itemdata)
            // console.log(this.datalist)
        },
        changeEdit(row){
            this.$set(row, '$Edit', true)
        },
        cancel(){
            this.$emit('on-close');
        },
        close(){
            this.operate.show = false;
        },
        async submit(){

            if(this.datalist.length<1){
                this.$Message.error(this.$t('erp.b2c.leastone_returndata',{defaultValue:'请填写至少一条回传数据'}));
                return
            }
            this.loading = true
            this.showDel = true
            await HttpManualBack({
                id: this.id,
                contextId: global.SYSID,
                saleShipmentPackagesList: this.datalist
            }).then(res => {
                this.$VMessage.success(res.message);
                this.operate.show = false;
                this.$emit('on-close');
                this.$emit('on-update');
            }, err => {
                this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true
                    });
            }).finally(() => {
                this.showDel = false;
                this.loading = false;
            })
        },
        comremove(index) {
            this.datalist.splice(index, 1);
        }
    }
}
</script>
